import { inject, observer } from 'mobx-react';
import React, { Component, Fragment } from 'react';
import ReactTooltip from 'react-tooltip';
import { numberFormat } from '../../common';
import Keyboard from '../keyboard/keyboardInput';
import VipBox from './vipBox';
import { get } from 'lodash';

@inject('lineStore', 'dictStore', 'accountStore')
@observer
export default class Win extends Component {

  vipTooltipRef = null;

  handleSelect = (type) => {
    this.props.lineStore.basket.setType(type);
  }

  handleChange = (e) => {
    this.props.lineStore.basket.newOnExpressOrSystemAmountInput(e);
  }

  handleVip = (isVip) => {
    this.props.lineStore.basket.newSetIsVipBet(isVip);
  }

  render() {
    const { mode, } = this.props.lineStore.basket;
    const basketData = this.props.lineStore.basket.basketData;
    const betType = get(basketData, 'betType')
    const amount = get(basketData, 'amount')
    const possibleWin = get(basketData, 'possibleWin')
    const expressCoef = get(basketData, 'expressCoef')
    const isVipBet = get(basketData, 'isVipBet')
    const isAllOddsLine = get(basketData, 'isAllOddsLine')
    const maxExpress = get(basketData, 'maxExpress')
    const minVipExpress = get(basketData, 'minVipExpress')
    const { getLang } = this.props.dictStore;
    const { basketPosition } = this.props.accountStore.accountSettings;

    return (
      <Fragment>
        <div className="basket-express-coefficient">
          <div className="basket-possible-win-cont fl_l" title={getLang('POSSIBLE_WIN')}>
            <span>Выигрыш </span>
            <span className="basket-possible-win">
              {possibleWin ? numberFormat(possibleWin, 2, ',', ' ') : ' ~'}
            </span>
          </div>
          {betType == 2 && expressCoef ?
            <div className="basket-express-cont fl_r">
              <span title="Коэффициент">{getLang('CF')} </span>
              <span className="basket-express-cf">{expressCoef}</span>
            </div>
            : ''}
          <div className="clearfix"></div>
        </div>
        <div className="basket-row basket-amount-row">
          <div className="clearfix">
            {betType != 1 ?
              <div className="fl_r basket-amount-cont">
                <Keyboard
                  id="amount"
                  type="text"
                  className="input"
                  placeholder="1000"
                  onChange={this.handleChange}
                  value={amount}
                  tabIndex="1"
                  autoComplete="off"
                  size="10"
                  positionX={basketPosition == "left" ? 'right' : 'left'}
                  positionY="bottom"
                  maxLength="8"
                />
              </div>
              : ''}
            {maxExpress && !isVipBet && betType !== 1 ?
              <div className="basket-amount-max-cont">
                <span title="Максимальная сумма">{getLang('MAX')} </span>
                <span className="basket-amount-max">{numberFormat(maxExpress, 2, ',', ' ')}</span>
              </div>
              : ''}
            {isVipBet && isAllOddsLine && betType !== 1 ?
              <div className="basket-amount-vip-min-cont">
                <span title="Минимальная сумма">{getLang('MIN')} </span>
                <span className="basket-amount-vip-min">{numberFormat(minVipExpress, 2, ',', ' ')}</span>
              </div>
              : ''}
            <ReactTooltip />
            <div className="basket-vip-bet-cont"
              data-tip={!isAllOddsLine ? getLang('VIP_BET_NOT_ALLOWED_FOR_THIS_EVENT') : ''}
              ref={ref => (this.vipTooltipRef = ref)}
              data-multiline="true"
              data-place="left"
              data-type="light"
              data-border-color="black"
              data-effect="solid">
              <div className={`checkbox fl_l ${isVipBet && isAllOddsLine ? 'on' : ''}`}
                onClick={() => { isAllOddsLine && this.handleVip(!isVipBet); }}
                /** принудительно показываю подсказку, т.к при изменении data-tip сама не появляется */
                onMouseOver={() => { !isAllOddsLine && ReactTooltip.show(this.vipTooltipRef); }}
                onMouseOut={() => { !isAllOddsLine && ReactTooltip.hide(this.vipTooltipRef); }}>
                <span></span>
                <label className="basket-vip-bet_text">{getLang('VIP_BET')}</label>
              </div>
              <VipBox />
            </div>
            <div className="hidden">
              Событий:
              <span ></span>
            </div>
          </div>
        </div>
        <div className="basket-circles"></div>
      </Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/basket/win.js